import styled, { css } from 'styled-components';

const AvatarLetters = styled.div`
  display: flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  margin: auto;
  font-size: 14px;
  font-weight: bold;
  background-color: var(--grey200);
  color: white;
  border-radius: 50%;
  ${(props) =>
    !!props.background &&
    css`
      background-color: ${props.background};
    `}
`;

export default AvatarLetters;
